import { createAsyncThunk } from "@reduxjs/toolkit";
import { authBranchLogin, authLogin } from "../../Service/api/auth";

export const login = createAsyncThunk(
    'auth/login',
    async ({ email, password, hospital_code,role }: { email: string; password: string | number,role:any , hospital_code: string | number }) => {
        const response = await authLogin(email, password, hospital_code,role);
        // console.log(response);
        
        return response.response?{...response.response}:{ ...response.data, token: response.token, hospital_code };
    }
);

export const branchLogin = createAsyncThunk(
    'merchant_branch/login',
    async ({ email, password, hospital_code,branchId,role }: { email: string; password: string | number,role:any, hospital_code: string | number , branchId:number | null }) => {
        const response = await authBranchLogin(email, password, hospital_code,branchId,role);
        // console.log(response);
        
        return response.response?{...response.response}:{ ...response.data, token: response.token, hospital_code };
    }
);